import {SODeleteMedia} from '../../core/media/so-delete-media';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteMedia extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteMedia;
}